import { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import { DayBar } from '../components';
import {
  TabPanel,
  MobileNavigation,
  CalendarWhite,
  HomeIcon,
  ElementEqualIcon,
  BookOpenWhite,
  UsersIcon,
  HelpIcon,
  HomeIconFilled,
  CalendarIconFilled,
  FavoritesIcon,
  FavoritesIconFilled,
  MoreIcon,
  MoreIconFilled,
  LeftArrowIcon,
  HeartIcon,
  SunIcon,
  PlayIcon,
  VoiceSquare,
  AudioPlayer,
} from '../components';
import { fetchSingleDevotion, mapSingleDevotionsData, toggleFavorite } from '../utilities';
import useLiturgicalEvents from '../hooks/useLiturgicalEvents';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger
} from "src/components/ui/tabs"
import { Skeleton } from "../components/ui/skeleton";
import { useLocation } from 'react-router-dom';
import { SidebarLeft } from '../templates';
import { useParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import TrinityAudioPlayer from './TrinityAudioPlayer';
const mobileNavigationItems = [
  { id: 1, label: 'Home', defaultIcon: HomeIcon, activeIcon: HomeIconFilled, active: false },
  { id: 2, label: 'Calendar', defaultIcon: CalendarWhite, activeIcon: CalendarIconFilled, active: false },
  { id: 3, label: 'Favorites', defaultIcon: FavoritesIcon, activeIcon: FavoritesIconFilled, active: true },
  { id: 4, label: 'More', defaultIcon: MoreIcon, activeIcon: MoreIconFilled, active: false },
];

const mobileNavMoreOptionItems = [
  { label: 'Culture & Customs', href: '#222', Icon: ElementEqualIcon },
  { label: 'Prayer & Rites', href: '#111', Icon: BookOpenWhite },
  { label: 'Learn the Faith', href: '#333', Icon: UsersIcon },
  { label: 'Help', href: '#444', Icon: HelpIcon },
];
const isValidAudioUrl = (url) =>
  typeof url === "string" && /\.(mp3|ogg|wav)$/i.test(url);

function SingleDevotion({ }) {
  const [activeTab, setActiveTab] = useState("english");
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [activePlayerIndex, setActivePlayerIndex] = useState(null); // Track active audio player
  const [progress, setProgress] = useState(0);
  const audioRef = useRef(null);
  const [progressPercentage, setProgressPercentage] = useState(0);
  const [devotionData, setDevotionData] = useState(null)
  const { slug } = useParams();
  const [isLoading, setIsLoading] = useState(true)
  const today = new Date();
  const { isDataLoading, eventData } = useLiturgicalEvents(
    today.getFullYear(),
    today.getMonth() + 1,
    today.getDate()
  );
  // Ensure skeleton stays until API data is loaded
  useEffect(() => {
    if (!isDataLoading && eventData) {
      setIsLoading(false); // Hide skeleton only when API data is fully loaded
    }
  }, [isDataLoading, eventData]);
  // Extract relevant event details
  const firstEventKey = eventData ? Object.keys(eventData)[0] : null;
  const firstEvent = firstEventKey ? eventData[firstEventKey] : null;
  // Ensure no flickering or static data issues
  const dayData = isDataLoading
    ? {} //Show skeleton while loading (NO STATIC DATA)
    : {
      date: firstEvent?.date
        ? new Date(firstEvent.date * 1000).toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        })
        : "",
        title: firstEvent?.name
        ? firstEvent.name.replace(/\s*\/\/\s*/g, "  ")
        : "",
      tag: firstEvent?.liturgicalSeasonLcl || "",
      label: firstEvent ? "Today" : "",
      category: "Easter",
      description: firstEvent?.eventData?.description || '',
    };
  useEffect(() => {
    if (!slug) {
      console.error("No slug provided for devotion.");
      return;
    }
    setLoading(true);
    const loadDevotion = async () => {
      try {
        console.log(`Fetching devotion for slug: ${slug}`);
        const response = await fetchSingleDevotion(slug);
        if (!response) {
          console.error("No Data Returned from api for slug ", slug);
          setDevotionData(null);
          return;
        }
        const mapped = mapSingleDevotionsData(response);
        setDevotionData(mapped);
      } catch (error) {
        console.error("Failed to fetch devotion data:", error);
        setDevotionData(null); // Ensure state resets on failure
      } finally {
        setLoading(false);
      }
    };
    loadDevotion();
  }, [slug]);
  // Handle play button click
  // const handlePlayClick = (index) => {
  //   if (activePlayerIndex === index) {
  //     setActivePlayerIndex(null); // Stop current player
  //     if (audioRef.current) {
  //       audioRef.current.pause(); // Pause the audio
  //     }
  //   } else {
  //     setActivePlayerIndex(index); // Activate the selected player
  //     setTimeout(() => {
  //       if (audioRef.current) {
  //         audioRef.current.play(); // Start playing the audio
  //       }
  //     }, 0); // Ensure state updates before playback
  //   }
  // };
  const handlePlayClick = (index) => {
    const lang = index === 0 ? 'english' : 'latin';
    const valid = isValidAudioUrl(audioData[index].src);

    setActiveTab(lang);
  
    setTimeout(() => {
      if (valid) {
        setActivePlayerIndex(index);
        setTimeout(() => audioRef.current?.play(), 0);
      } else {
        setActivePlayerIndex(null);
      }
    }, 200);
  };
  
  // Handle closing the player
  const handleCloseAudioPlayer = () => {
    setActivePlayerIndex(null); // Close the player
    if (audioRef.current) {
      audioRef.current.pause(); // Pause the audio
    }
  };
  const handleProgressUpdate = (progress) => {
    setProgressPercentage(progress);
  };
  const handleToggleFavorite = async (event, id) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!devotionData || !id) return;
    const currentFavorite = devotionData.favorite
    try {
      const updatedFavoriteStatus = !devotionData.favorite;
      const catechesisId = String(devotionData.id);
      // Step 1: Optimistically update UI
      setDevotionData((prevData) => ({
        ...prevData,
        favorite: updatedFavoriteStatus,
      }));
      // Step 3: Call API (Do NOT reload everything)
      await toggleFavorite('devotions', catechesisId, false, currentFavorite);
    } catch (error) {
      console.error("Failed to update favorite:", error);
      // Step 4: If API call fails, revert UI
      setDevotionData((prevData) => ({
        ...prevData,
        favorite: !prevData.favorite,
      }));
    }
  };
  const audioData = [
    { title: "Play English", src: devotionData?.english_audio || "", excerpt: "English Language Audio" },
    { title: "Play Latin", src: devotionData?.latin_audio || "", excerpt: "Latin Language Audio" },
  ];
  const tabsData = devotionData ? [
    {
      value: "english",
      label: "English",
      content: <div dangerouslySetInnerHTML={{ __html: devotionData.english }} />,
    },
    {
      value: "latin",
      label: "Latin",
      content: <div dangerouslySetInnerHTML={{ __html: devotionData.latin }} />,
    },
  ] : [];
  return (
    <div className='relative w-full bg-white-50'>
      <div className='xl:px-12 px-6 pt-7.5 pb-15 flex justify-between bg-custom-gradient'>
        <div className='flex'>
          <Link to="/" className='flex items-center justify-center rounded-full bg-white-50 md:h-11 md:w-11 h-9 w-9 group'>
            {loading ? <Skeleton className="rounded-full h-7 w-7" /> : <LeftArrowIcon className="text-gray-700 group-hover:text-gold-500" />}
          </Link>
          <div className='flex flex-col max-w-2xl pl-4'>
            {/* <p className='text-base text-left font-normal text-gray-600 font-redhat leading-6.5'> {loading ? <Skeleton className="h-4 rounded w-38" /> : "May 1, 2024"}</p>
            <h5 className="text-xl font-bold text-gray-900 underline leading-26 font-cmr"> {loading ? <Skeleton className="w-40 h-4 mt-1 rounded" /> : "Liturgical Day"}</h5> */}
            <DayBar isLoading={loading} title={dayData?.title} date={dayData?.date} hideIcon={true} />
            {console.log(dayData?.title, "=======>>>>>>>>>>")
            }
          </div>
        </div>
        <div>
          <button
            key={devotionData?.favorite}
            type="button"
            onClick={(e) => devotionData && handleToggleFavorite(e, devotionData.id)}
            disabled={!devotionData}
            className="flex items-center justify-center rounded-full bg-white-50 md:h-11 md:w-11 h-9 w-9 group">
            {
              devotionData ? (
                <FavoritesIcon filled={Boolean(devotionData?.favorite)} className={`text-gray-700 w-7 h-7  group ${devotionData?.favorite ? 'text-red-500' : 'text-gray-500 hover:text-red-500'
                  }`} />
              ) : (
                <Skeleton className="w-6 h-6 rounded" />
              )
            }
          </button>
        </div>
      </div>
      <div className="flex flex-col px-6 xl:flex-row">
        {/* Left Section */}
        <div className="w-full px-0 -mt-8 xl:w-2/6 xl:px-6 z-2">
          <div className="p-2 rounded-lg border-5 border-white-50 bg-gold-50 w-max">
            <SunIcon className="text-gold-200" />
          </div>
          <div className="pt-8">
            <h2 className='pb-2 text-2xl font-bold text-gray-900'> {loading ? (
              <Skeleton className="w-48 h-6 rounded" />
            ) : (
              devotionData?.title || 'Morning Devotion'
            )}</h2>
            <p className='font-normal text-gray-800'>
              {
                loading ? (
                  <Skeleton className="w-48 h-6 rounded" />
                ) : (
                  devotionData?.excerpt
                )
              }
            </p>
          </div>
          <div className='mt-8'>
          {audioData.map((audio, index) => (
            <div
              key={index}
              onClick={(e) => {
                e.preventDefault(); // Prevent default link behavior
                handlePlayClick(index); // Play or pause based on the current state
              }}
              className="cursor-pointer w-full max-w-[320px] bg-gold-300 rounded-[50px] p-2 flex items-center justify-between my-2"
            >
              {/* Play/Pause Button */}
              <div className="flex items-center justify-center rounded-full bg-gold-200 md:h-11 md:w-11 h-9 w-9">
                {activePlayerIndex === index ? (
                  <VoiceSquare progress={progressPercentage / 100} />
                ) : (
                  <PlayIcon className="text-gray-0" />
                )}
              </div>
              {/* Audio Title */}
              <div className="flex items-center justify-center flex-grow select-none">
                <p className="text-lg font-bold text-gray-0">{audio.title}</p>
              </div> 
             </div>
          ))}
          </div>
        
        </div>
        <div className="absolute border-0 border-gray-300 top-[167px] left-33 xl:border-r xl:min-h-screen"></div>
        {/* Right Section */}
        <div className="w-full pt-8 pl-0 pr-0 xl:w-4/6 xl:pr-6 xl:pl-12">
          {/* Tabs usign a shadcn start */}
          <Tabs defaultValue="english" value={activeTab} onValueChange={setActiveTab} className="bg-white-50 ">
            <TabsList className="relative flex flex-col justify-around w-full h-auto border-gray-100 rounded-none border-b-1 md:flex-row bg-white-50">
              <div className="flex flex-row w-full md:items-center">
                {tabsData.map((tab) => (
                  <TabsTrigger
                    key={tab.value}
                    value={tab.value}
                    className="-mb-[13px] p-4 text-gray-400 text-base leading-5 font-semibold cursor-pointer font-redhat !shadow-none border-b-1 border-transparent data-[state=active]:text-gold-500 data-[state=active]:border-gold-500 rounded-none"
                  >
                    {tab.label}
                  </TabsTrigger>
                ))}
              </div>
              <div className="flex w-full md:place-content-end">
                {/* ShortForm Label */}
                <div className="p-4">
                  <label
                    htmlFor="shortform"
                    className={`text-sm  leading-4.5 ${isChecked ? 'cursor-pointer text-gray-400 font-normal' : 'text-gray-800 font-medium'}`}
                  >
                    Short Form
                  </label>
                </div>
                {/* Switch Toggle */}
                <div className="flex items-center justify-center">
                  <label className="cursor-pointer relative block w-[45px] h-[23px] bg-gold-600 rounded-58 p-1.15 overflow-visible">
                    <input
                      type="checkbox"
                      id="shortform"
                      className="invisible w-0 h-0 sr-only"
                      checked={isChecked}
                      onChange={() => setIsChecked(!isChecked)}
                    />
                    {/* Slider Circle */}
                    <span className={`absolute top-[1px] left-[1px] w-[23px] h-[21px] z-10 bg-white-50 rounded-58 transition-transform duration-300 ${isChecked ? 'translate-x-[20px]' : ""
                      } `}>
                    </span>
                    {/* Display "S" on the opposite side of the toggle */}
                    <span
                      className={`absolute top-[50%] transform -translate-y-[50%] text-white-50 font-medium  leading-4.5 text-sm  ${isChecked ? 'left-[5px]' : 'right-[5px]'
                        }`}
                    >
                      {isChecked ? 'L' : 'S'}
                    </span>
                  </label>
                </div>
                {/* LongForm Label */}
                <div className="p-4">
                  <label
                    htmlFor="longform"
                    className={`text-sm leading-4.5 ${!isChecked ? 'cursor-pointer text-gray-400 font-normal' : 'text-gray-800 font-medium'}`}
                  >
                    Long Form
                  </label>
                </div>
              </div>
            </TabsList>
            {tabsData.map((tab, index) => (
              <TabsContent key={index} value={tab.value} className="w-full max-w-full font-normal leading-7 text-left text-gray-900 font-redhat text-18">

                {
                  loading ? (
                    <div className='w-1/2 h-4 rounded'>
                      <Skeleton className="w-1/2 h-4 rounded" />
                    </div>
                  ) : (
                    <div className="content entry-content my-audio-content">
                      {
                        !isValidAudioUrl(audioData[index]?.src) && (

                          <TrinityAudioPlayer selector=".my-audio-content" key={`trinity-${tab.value}`} langKey={tab.value} />
                        )
                      }
                    {tab.content}
                </div>
                  )
                }
              </TabsContent>
            ))}
          </Tabs>
        </div>
      </div>
      {/* Conditionally render AudioPlayer with animation */}
      <div className='fixed bottom-0 xl:left-[16.66%] md:left-[15rem] left-0 right-0 z-50'>
        <div
          className={`transition-transform duration-500 ease-out transform bg-gray-0 ${activePlayerIndex !== null ? "animate-slideUp" : "animate-slideDown"
            }`}
        >
          {activePlayerIndex !== null && (
            <AudioPlayer
              src={audioData[activePlayerIndex].src}
              title={audioData[activePlayerIndex].title}
              excerpt={audioData[activePlayerIndex].excerpt}
              onClose={handleCloseAudioPlayer}
              audioRef={audioRef}
              onProgressUpdate={handleProgressUpdate}
            // Pass the ref to control audio
            />
          )}
        </div>
      </div>
    </div>
  );
}
export default SingleDevotion;